module.exports = "<ng-template #mapComponentElem></ng-template>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/src/app/packages/imagery/imagery-component/imagery.component.html
// module id = ../../../../../src/app/packages/imagery/imagery-component/imagery.component.html
// module chunks = main